import React, { useState, useEffect } from 'react';
import { useAuth } from '../../services/auth';
import ChatWindow from './ChatWindow';
import Icon from '../Icon';

const EXCLUDED_HASHES = ['rag-chat', 'assistant', 'login'];

function readHashExcluded() {
  const hash = (window.location.hash || '').replace('#', '').split('/')[0];
  return EXCLUDED_HASHES.includes(hash);
}

export default function FloatingChatWidget() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [excluded, setExcluded] = useState(readHashExcluded);

  useEffect(() => {
    const onHash = () => {
      setExcluded(readHashExcluded());
      setOpen(false);
    };
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  if (!user || excluded) return null;

  const isBrain = user?.role === 'super_admin';
  const mode = isBrain ? 'admin' : 'operator';
  const gradient = mode === 'admin'
    ? 'linear-gradient(135deg, #6366f1, #8b5cf6)'
    : 'linear-gradient(135deg, #10b981, #14b8a6)';

  return (
    <div className="synoti-ui" style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 50 }}>
      <ChatWindow open={open} mode={mode} isBrain={isBrain} onClose={() => setOpen(false)} />
      <button
        onClick={() => setOpen(o => !o)}
        title={isBrain ? 'Synoti Brain' : 'Synoti Assistant'}
        aria-label={open ? 'Close chat' : 'Open chat'}
        style={{
          width: 56, height: 56, borderRadius: '50%', border: 'none', cursor: 'pointer',
          background: gradient, display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 10px 30px rgba(0,0,0,0.45), 0 2px 8px rgba(0,0,0,0.3)',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        }}
        className={open ? 'hover:scale-105' : 'hover:scale-105'}
      >
        <span style={{ display: 'flex', transition: 'transform 0.3s ease', transform: open ? 'rotate(90deg)' : 'none' }}>
          <Icon name={open ? 'circle-x' : 'message-square'} size={24} style={{ color: '#fff' }} />
        </span>
      </button>
    </div>
  );
}
